module.exports = __webpack_public_path__ + "static/media/s9.cb739972.png";